import { ApplicationConstants } from '../../../../shared/applicationConstants';
import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class BorrarMapaService {

    static deleteMap(businessId){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.delteMapUrl, { uid: uid, token: token, businessId: businessId}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/perfil/components/borrar-modal/services/borrarMapaService.js